module.exports = __webpack_public_path__ + "img/MEDIA081.5dbc33a8.jpg";